import React, { memo } from 'react';
import AddressSearch from '../CommonFields/AddressSearch';
import PostalFields from '../CommonFields/PostalFields';
import CareOfFields from '../CommonFields/CareOfFields';
import { PresentationMode } from '../../../../Enums/PresentationMode';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import TextInput from '../../../ids/InputElements/TextInput';
import AddressCountrySelector from '../CommonFields/AddressCountrySelector';
import ErrorMessage from '../../../ErrorMessage';

const FreeTextAddress = ({ getCommonFields, modalMode, addressState, setAddressState, countryList }) => {
  return (
    <>
      {modalMode === PresentationMode.Add && (
        <AddressSearch addressState={addressState} setAddressState={setAddressState} />
      )}

      <CareOfFields modalMode={modalMode} addressState={addressState} setAddressState={setAddressState} />

      <TextInput label={formatMessage(Messages.addressInfo_additionalLine)} {...getCommonFields('additionalAddress')} />

      <AddressCountrySelector addressState={addressState} countryList={countryList} setAddressState={setAddressState} />
      <PostalFields
        key={addressState.address.postalCode}
        getCommonFields={getCommonFields}
        setAddressState={setAddressState}
        addressState={addressState}
      />

      <ErrorMessage message={formatMessage(Messages.addressInfo_FreeTextAddressNotSupported)} />
    </>
  );
};

export default memo(FreeTextAddress);
